"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable react/no-unused-prop-types */
/**
 * Prop types are kept optional so Flow does not error with partial application.
 */
var BasicTooltip = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(BasicTooltip, _PureComponent);
  function BasicTooltip() {
    (0, _classCallCheck2["default"])(this, BasicTooltip);
    return _callSuper(this, BasicTooltip, arguments);
  }
  (0, _createClass2["default"])(BasicTooltip, [{
    key: "resolveCalculatedProps",
    value: function resolveCalculatedProps() {
      var _this$props = this.props,
        datum = _this$props.datum,
        rows = _this$props.rows,
        title = _this$props.title;
      var calculatedTitle = typeof title === 'function' ? title(datum) : title;
      if (!(typeof calculatedTitle === 'number' || typeof calculatedTitle === 'string')) {
        throw new Error('BasicTooltip Component: \'title\' prop must resolve to a number or string.');
      }
      var calculatedRows = rows.map(function (r) {
        return {
          color: r.color,
          label: r.label,
          value: r.value(datum)
        };
      });
      return {
        title: calculatedTitle,
        rows: calculatedRows
      };
    }

    /**
     * The default tooltip renderer renders a box containing two main sections:
     * 1. A title: The x-axis dimension value at current mouse location. E.g. "api1"
     * 2. Rows: The y-axis values for every dimension being charted, E.g.
     *    "Max latency: 55ms | Average Latency: 22ms"
     * @returns ReactNode
     */
  }, {
    key: "renderDefaultTooltip",
    value: function renderDefaultTooltip() {
      var _this$resolveCalculat = this.resolveCalculatedProps(),
        title = _this$resolveCalculat.title,
        rows = _this$resolveCalculat.rows;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          backgroundColor: 'white',
          borderStyle: 'solid',
          borderWidth: 1,
          borderColor: '#989A9B',
          // aluminum5
          height: '100%',
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          borderBottomStyle: 'solid',
          borderBottomWidth: 1,
          borderBottomColor: '#989A9B',
          // aluminum5
          height: 25,
          lineHeight: '25px',
          overflow: 'hidden',
          textAlign: 'center',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%'
        }
      }, title), /*#__PURE__*/_react["default"].createElement("div", null, rows.map(function (currentRow, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          style: {
            alignItems: 'center',
            display: 'flex',
            height: 20,
            paddingTop: 10,
            paddingLeft: 10,
            paddingRight: 10
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            backgroundColor: currentRow.color,
            borderRadius: '50%',
            flex: '0 0 10px',
            height: 10
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            fontSize: 12,
            paddingLeft: 5,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          }
        }, currentRow.label), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            flexGrow: 1,
            fontSize: 12,
            paddingLeft: 2,
            textAlign: 'right'
          }
        }, currentRow.value));
      })));
    }
  }, {
    key: "render",
    value: function render() {
      /** Need to do this check manually since prop types optional. */
      var _this$props2 = this.props,
        datum = _this$props2.datum,
        height = _this$props2.height,
        rows = _this$props2.rows,
        title = _this$props2.title,
        width = _this$props2.width;
      if (!datum || !height || !width || !rows || !title) {
        return null;
      }
      var _this$props3 = this.props,
        anchorX = _this$props3.anchorX,
        plotWidth = _this$props3.plotWidth,
        plotOffset = _this$props3.plotOffset,
        tooltipRenderer = _this$props3.tooltipRenderer,
        testId = _this$props3.testId;
      var offsetX = plotOffset ? plotOffset.x : 0;
      var left = anchorX + width > plotWidth ? anchorX - width - BasicTooltip.crossHairSeparation + offsetX : anchorX + offsetX + BasicTooltip.crossHairSeparation;

      // Render the tooltip using either a user-provided rendering routine
      // or the default built-in one
      var tooltip = tooltipRenderer ? tooltipRenderer(datum) : this.renderDefaultTooltip();
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: height,
          width: width,
          left: left,
          top: 0,
          position: 'absolute',
          zIndex: 1
        },
        "data-test-id": testId
      }, tooltip);
    }
  }], [{
    key: "getBaseHeight",
    value: function getBaseHeight(rowCount) {
      return BasicTooltip.defaultPadding + BasicTooltip.defaultRowHeight * rowCount;
    }
  }]);
  return BasicTooltip;
}(_react.PureComponent);
//eslint-disable-line
(0, _defineProperty2["default"])(BasicTooltip, "defaultPadding", 25);
(0, _defineProperty2["default"])(BasicTooltip, "defaultRowHeight", 30);
(0, _defineProperty2["default"])(BasicTooltip, "crossHairSeparation", 5);
var _default = exports["default"] = BasicTooltip;
//# sourceMappingURL=BasicTooltip.js.map